import { useState } from 'react'
import { ActionMenu } from '@atrvd/saas-ui'
import { hasPermission } from '@dcp/shared'
import { useProfile } from '@/hooks/useProfile'
import type { FileImportRow } from '@/types/banking'
import { DeleteTransactionImportDialog } from './DeleteTransactionImportDialog'

/**
 * Kebab menu on a Transactions Import history row. Offers "Delete Transactions"
 * only for a `completed` import and only to roles with `manage_banking` — the
 * RPC enforces both again server-side; this just keeps the action out of reach
 * where it would be refused. Renders nothing otherwise.
 */
export function TransactionImportRowActions({ fileImport }: { fileImport: FileImportRow }) {
  const { data: profile } = useProfile()
  const [confirming, setConfirming] = useState(false)

  if (fileImport.status !== 'completed') return null
  if (!hasPermission(profile?.productRole, 'manage_banking')) return null

  return (
    <>
      <ActionMenu
        ariaLabel={`Actions for ${fileImport.file_name}`}
        items={[
          {
            id: 'delete',
            label: 'Delete Transactions',
            variant: 'danger',
            onClick: () => setConfirming(true),
          },
        ]}
      />
      {confirming && (
        <DeleteTransactionImportDialog fileImport={fileImport} onClose={() => setConfirming(false)} />
      )}
    </>
  )
}
